import { faSpinner } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";

export default class LoadingIcon extends React.Component<{}, {}> {
  public render() {
    return <FontAwesomeIcon icon={faSpinner} spin size={"lg"} />;
  }
}
